import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IMoveToProjectParams } from '../../../ts/ServerApi/types/IMoveToProjectParams';

export class MoveFlowDraftsToProjectRequest extends Request<IMoveToProjectParams, IResult> {
  constructor(params: IMoveToProjectParams) {
    super('moveFlowDraftsToProject', params);
  }
}
